export const breadcrumbJsonLD = {
  '@context': 'https://schema.org/',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '그룹바이',
      item: 'https://groupby.kr',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '채용 공고',
      item: 'https://groupby.kr/positions',
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: '스카우트 제안받기',
      item: 'https://groupby.kr/scouts',
    },
    {
      '@type': 'ListItem',
      position: 4,
      name: '기업 서비스',
      item: 'https://groupby.kr/biz',
    },
    {
      '@type': 'ListItem',
      position: 5,
      name: '연봉진단하기',
      item: 'https://groupby.kr/salary-analysis/landing',
    },
    {
      '@type': 'ListItem',
      position: 6,
      name: '합격하는이력서',
      item: 'https://groupby.kr/landing/resume',
    },
  ],
}
